/* global axios */
import ApiClient from '../ApiClient';

class CrmDealsAPI extends ApiClient {
  constructor() {
    super('crm_deals', {
      saas: true,
      accountScoped: true,
    });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  create(data) {
    return axios.post(this.url, { crm_deal: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { crm_deal: data });
  }

  // Spelled out rather than inherited from ApiClient so the whole deal API
  // reads from one place, next to the wrapper the other writes need.
  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  move(id, data) {
    return axios.patch(`${this.url}/${id}/move`, data);
  }
}

export default new CrmDealsAPI();
